module.exports = __webpack_public_path__ + "media/images/gallery/constellations/snr_layer_on-162ff5be78613f4039616ce2dc0be372.png";